(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["covva-compromis"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-cvco-scroll]');
    if (!trigger) { return; }
    var href = trigger.getAttribute('href') || '';
    if (href.charAt(0) !== '#' || href.length < 2) { return; }
    var target = document.querySelector(href);
    if (!target) { return; }
    event.preventDefault();
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["covva-contextes"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSection(section) {
    if (!section || section.dataset.cvcxReady === 'true') { return; }
    section.dataset.cvcxReady = 'true';
    section.classList.add('cvcx-js');

    var carousel = section.querySelector('[data-cvcx-grid]');

    // Dots : synchro avec la position du carrousel mobile.
    var dots = section.querySelectorAll('.cvcx-dot');
    var cards = section.querySelectorAll('.cvcx-card');
    if (carousel && dots.length > 1 && cards.length && 'IntersectionObserver' in window) {
      var dotObserver = new IntersectionObserver(function (entries) {
        for (var e = 0; e < entries.length; e++) {
          if (entries[e].isIntersecting && entries[e].intersectionRatio >= 0.55) {
            var idx = Array.prototype.indexOf.call(cards, entries[e].target);
            if (idx >= 0) {
              for (var d = 0; d < dots.length; d++) {
                dots[d].classList.toggle('is-active', d === idx);
              }
            }
          }
        }
      }, { root: carousel, threshold: [0.55] });
      for (var c = 0; c < cards.length; c++) { dotObserver.observe(cards[c]); }
    }

    // Apparition au scroll.
    var trigger = carousel || section;

    function reveal() { section.classList.add('cvcx-in'); }

    if (reduceMotion || !('IntersectionObserver' in window)) {
      reveal();
      return;
    }

    var done = false;
    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting && !done) {
          done = true;
          observer.disconnect();
          reveal();
        }
      }
    }, { threshold: 0.2 });

    observer.observe(trigger);
  }

  function initAll() {
    var list = document.querySelectorAll('.cvcx-section');
    for (var i = 0; i < list.length; i++) { initSection(list[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target;
    if (!root) { return; }
    var section = (root.classList && root.classList.contains('cvcx-section'))
      ? root
      : (root.querySelector ? root.querySelector('.cvcx-section') : null);
    if (section) { initSection(section); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["covva-usecase"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSection(section) {
    if (!section || section.dataset.cvuqReady === 'true') { return; }
    section.dataset.cvuqReady = 'true';
    section.classList.add('cvuq-js');

    var carousel = section.querySelector('[data-cvuq-grid]');
    var dots = section.querySelectorAll('.cvuq-dot');
    var cards = section.querySelectorAll('.cvuq-card');

    if (carousel && dots.length > 1 && cards.length && 'IntersectionObserver' in window) {
      var dotObserver = new IntersectionObserver(function (entries) {
        for (var e = 0; e < entries.length; e++) {
          if (entries[e].isIntersecting && entries[e].intersectionRatio >= 0.55) {
            var idx = Array.prototype.indexOf.call(cards, entries[e].target);
            if (idx >= 0) {
              for (var d = 0; d < dots.length; d++) {
                dots[d].classList.toggle('is-active', d === idx);
              }
            }
          }
        }
      }, { root: carousel, threshold: [0.55] });
      for (var c = 0; c < cards.length; c++) { dotObserver.observe(cards[c]); }
    }

    var trigger = carousel || section;
    function reveal() { section.classList.add('cvuq-in'); }

    if (reduceMotion || !('IntersectionObserver' in window)) {
      reveal();
      return;
    }

    var done = false;
    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting && !done) {
          done = true;
          observer.disconnect();
          reveal();
        }
      }
    }, { threshold: 0.2 });
    observer.observe(trigger);
  }

  function initAll() {
    var list = document.querySelectorAll('.cvuq-section');
    for (var i = 0; i < list.length; i++) { initSection(list[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target;
    if (!root) { return; }
    var section = (root.classList && root.classList.contains('cvuq-section'))
      ? root
      : (root.querySelector ? root.querySelector('.cvuq-section') : null);
    if (section) { initSection(section); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq-specs-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__cvTabsInit) return;
  window.__cvTabsInit = true;

  function initRoot(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length || !panels.length) return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function setActive(tabId) {
      tabs.forEach(function (t, i) {
        var match = t.dataset.cvtab === tabId;
        t.classList.toggle('is-active', match);
        t.setAttribute('aria-selected', match ? 'true' : 'false');
        t.setAttribute('tabindex', match ? '0' : '-1');
      });
      panels.forEach(function (p) {
        var match = p.dataset.cvpanel === tabId;
        if (match) {
          p.hidden = false;
          if (reduceMotion) {
            p.classList.add('is-active');
          } else {
            requestAnimationFrame(function () {
              requestAnimationFrame(function () { p.classList.add('is-active'); });
            });
          }
        } else {
          p.classList.remove('is-active');
          if (reduceMotion) {
            p.hidden = true;
          } else {
            window.setTimeout(function () {
              if (!p.classList.contains('is-active')) p.hidden = true;
            }, 160);
          }
        }
      });
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { setActive(tab.dataset.cvtab); });
      tab.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var dir = e.key === 'ArrowRight' ? 1 : -1;
          var next = (i + dir + tabs.length) % tabs.length;
          tabs[next].focus();
          setActive(tabs[next].dataset.cvtab);
        } else if (e.key === 'Home') {
          e.preventDefault();
          tabs[0].focus();
          setActive(tabs[0].dataset.cvtab);
        } else if (e.key === 'End') {
          e.preventDefault();
          tabs[tabs.length - 1].focus();
          setActive(tabs[tabs.length - 1].dataset.cvtab);
        }
      });
    });

    var faqItems = Array.prototype.slice.call(root.querySelectorAll('.cvtabs__item'));
    faqItems.forEach(function (item) {
      var inner = item.querySelector('.cvtabs__a-inner');
      if (!inner) return;
      item.addEventListener('toggle', function () {
        if (item.open) {
          faqItems.forEach(function (other) {
            if (other !== item && other.open) other.open = false;
          });
          item.style.setProperty('--cvtabs-max', inner.scrollHeight + 16 + 'px');
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-cvtabs]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
